import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../Services/ApiService";
import { setLanguages } from "../store/language/actions";
import { addRightSectionSpinner, removeRightSectionSpinner, setTranslations } from "../store/actions";
import AlertService from "../Services/alertService";
import { ERROR_KEY } from "../Constants/MainKeys";
import uuid from "react-uuid";

const LangProvider = ({ children }) => {

	const dispatch = useDispatch();
	const { user } = useSelector(state => state.Login);
	const { language, languages } = useSelector(state => state.Languages);

	useEffect(() => {
		getLanguages();
	}, []);

	const getLanguages = () => {
		// todo, minchev backendy kta endpoint
		return false;

		const spinnerId = uuid();
		setRightSectionSpinner(spinnerId);
		ApiService.getLanguages()
			.then(response => {
				if (response && response.data && response.data.length) {
					dispatch(setLanguages(response.data))
				} else {
					dispatch(setLanguages([]));
				}
			})
			.catch((error) => { getFail(error) }).finally(() => {
				extractRightSectionSpinner(spinnerId)
			});
	};

	useEffect(() => {
		if (language) {
			localStorage.setItem("language", language);
			setTimeout(() => {
				getTranslations();
			}, 100);
		}
	}, [language]);


	const getTranslations = () => {
		// todo, minchev backendy kta endpoint
		return false;

		const spinnerId = uuid();
		setRightSectionSpinner(spinnerId);
		ApiService.getAllTranslations().then(response => {
			if (response && response.data && response.data.length) {
				dispatch(setTranslations(response.data))
			} else {
				dispatch(setTranslations([]));
			}
		})
			.catch((error) => { getFail(error) }).finally(() => {
				extractRightSectionSpinner(spinnerId)
			});
	};

	const setRightSectionSpinner = useCallback(spinner => {
		dispatch(addRightSectionSpinner(spinner));
	}, []);

	const extractRightSectionSpinner = useCallback(spinner => {
		dispatch(removeRightSectionSpinner(spinner));
	}, []);

	const getFail = (error) => {
		error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
	}


	return <React.Fragment>{children}</React.Fragment>;
};
export default LangProvider;
